import { useNavigate } from 'react-router-dom';
import { JobSearchInput } from '../../features/jobs/search/components/JobSearchInput';

export const GoToJobSearch = () => {
  const navigate = useNavigate();

  return <JobSearchInput mode='navigate' onNavigate={(job) => navigate(`/legacy/editjob?jobId=${job.JobId}`)} />;
};
